<template>
  <!-- The top of the side menu (Mohammed 04/10/2026): the system's name as the menu's title, then
       the signed-in user's name and email as plain text in the menu's normal text colour. No logo,
       no expand arrow, no "Profile" option (there is no profile page); the account actions live in
       the top bar's avatar menu. -->
  <div class="layout-profile">
    <div class="layout-profile-button layout-profile-static">
      <div class="layout-menu-title">MBP Group Synergy system</div>
      <div v-if="getProfile" class="layout-profile-userinfo">
        <span class="layout-profile-role">{{ getProfile.fullName }}</span>
        <span class="layout-profile-name">{{ getProfile.email }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppInlineProfile",
  props: {
    // Still passed by App.vue; nothing expands any more.
    expanded: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    getProfile() {
      return this.$store.getters['auth/getMyProfile']
    }
  }
};
</script>

<style lang="scss">
/* Not scoped: the colours follow the menu theme class on .layout-wrapper. */
.layout-menu-container .layout-profile .layout-profile-static {
  cursor: default;
  padding: 16px 14px 14px;

  &:hover {
    background-color: transparent !important;
  }

  .layout-menu-title {
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 8px;
  }

  .layout-profile-userinfo {
    display: block;
    margin-left: 0 !important;
  }

  .layout-profile-role,
  .layout-profile-name {
    display: block;
    font-weight: 400 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .layout-profile-role {
    font-weight: 600 !important;
  }
}

/* Dark menu: the same colours as the menu items below (App.vue sets those white, bold). */
.layout-wrapper.layout-menu-dark .layout-menu-container .layout-profile .layout-profile-static {
  .layout-menu-title,
  .layout-profile-role {
    color: #ffffff;
  }

  .layout-profile-name {
    color: #bdbdbd;
  }
}

/* Light menu: the menu's normal text colour. */
.layout-wrapper.layout-menu-light .layout-menu-container .layout-profile .layout-profile-static {
  .layout-menu-title {
    color: #212121;
  }

  .layout-profile-role,
  .layout-profile-name {
    color: #495057;
  }
}
</style>
